<template>
    <div class="dish">
        <InfoBubble class="dish__info" />
        <figure class="dish__image" :style="{ backgroundImage: `url(${image})` }"></figure>
        <!-- <h3 class="dish__title">{{ title }}</h3>

        <div class="debug">
            breadUnits: {{ breadUnits }} <br>
            kcals: {{ kcals }} <br>
        </div>

        <p v-if="station" class="dish__location">
            <svgicon icon="pin" class="dish__svg" color="currentColor"></svgicon>
            {{ station.label ? `${station.label} / ` : '' }}{{ station.title }}
            {{ station.sections.map(item => item.title).join(', ') }}
            <span class="debug"><br><strong>{{ diet.title }}</strong>: {{ intolerances | implode }}</span>
        </p> -->
    </div>
</template>

<script>
import { wrapFunction } from '../js/utils.js';

export default {
    name: 'Dish',
    mounted() {},
    props: {
        image: String,
        breadUnits: Number,
        kcals: Number,
        station: Object,
        intolerances: Array,
        category: String,
        diet: Object,
        title: String,
        name: String,
        id: Number,
        sections: Array
    }
}
</script>

<style lang="scss">

@import '../scss/config';

.dish {
    position: relative;

    & + & {
        margin-left: size(tiny);
    }

    &__info {
        position: absolute;
        top: size(small);
        right: size(small);
    }

    &__title {
        font-size: size(font-small);
        margin-top: size(small);
        margin-bottom: size(small);
    }

    &__image {
        display: block;
        margin: 0;
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        background-size: cover;
        background-position: center center;
        background-color: faint-color(foreground, 0.9);
    }

    &__location {
        position: relative;
        color: color(accent-secondary);
        font-size: size(font-tiny);
        margin: 0;
        padding-left: size(font-regular);
    }

    &__svg {
        width: size(font-regular);
        height: size(font-regular);
        position: absolute;
        left: rem(-2);
        top: rem(-2);
    }
}
</style>
